export default __webpack_public_path__ + "static/media/call-transfer.48f9fbd6.svg";